import authSaga from "@rentiohq/shared-frontend/dist/redux/auth/auth.saga";
import contactSaga from "@rentiohq/shared-frontend/dist/redux/contact/contact.saga";
import countSaga from "@rentiohq/shared-frontend/dist/redux/count/count.saga";
import featureFlagSaga from "@rentiohq/shared-frontend/dist/redux/featureFlag/featureFlag.saga";
import requirementsSaga from "@rentiohq/shared-frontend/dist/redux/requirements/requirements.saga";
import { authModule } from "@rentiohq/shared-frontend/dist/reduxV2/auth";
import { bankAccountModule } from "@rentiohq/shared-frontend/dist/reduxV2/bankAccount";
import { paymentRequestModule } from "@rentiohq/shared-frontend/dist/reduxV2/paymentRequest";
import { propertyModule } from "@rentiohq/shared-frontend/dist/reduxV2/property";
import { all, fork } from "redux-saga/effects";

// eslint-disable-next-line import/no-default-export
export default function* sagas() {
  yield all([
    fork(authSaga),
    fork(authModule.saga),
    fork(bankAccountModule.saga),
    fork(paymentRequestModule.saga),
    fork(contactSaga),
    fork(countSaga),
    fork(featureFlagSaga),
    fork(propertyModule.saga),
    fork(requirementsSaga),
  ]);
}
